import React from 'react';
import { Container } from 'react-bootstrap';

function ChinaSection() {
  return (
    <Container>
      <div className='card mt-4'>
        <div className='card-body'>
          <h2>China</h2>
          <p>Is a country in East Asia. With a population exceeding
            1.4 billion, it is the world's second-most populous country.
            With an area of nearly 9.6 million square kilometers (3,700,000 sq mi),
            it is the third-largest country by total land area. The country is
            divided into 33 province-level divisions, inclusive of 22 provinces,
            five autonomous regions, four municipalities, and two semi-autonomous
            special administrative regions. Beijing is the national capital, while
            Shanghai is its most populous city and largest financial center.
          </p>
          <p>
            The current gobernor of the country is Xi Jimping, who assumend the power
            in November 2012.
          </p>
        </div>
        <div className='ratio ratio-4x3'>
          <iframe width="400" height="400" src="https://www.youtube.com/embed/q7JK5Vxf_VQ?si=t3v2EVWzAW1mC5Eq" title="YouTube video player"
            frameBorder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
            referrerPolicy="strict-origin-when-cross-origin" allowFullScreen>
          </iframe>
        </div>
      </div>
      <br></br>
    </Container>
  );
}

export default ChinaSection;
